/*global videojs*/

import { selectMenuItem } from './menu-handlers';
import {changeAudioTrack} from "../../../sync-x/client/js/client";

export function changeAudio(requestedAudioName, audioItems) {
    
	if (window.isWebRTC) {
		const idx      = window.audioNames?.indexOf(requestedAudioName) ?? -1;
		const trackId  = window.webRtcAudioTrackIds?.[idx] ??
						 window.webRtcAudioTrackIds?.[0]; // fallback
		if (typeof window.msSwitchTrack === 'function')
		  window.msSwitchTrack('audio', trackId);

		localStorage.setItem('selectedAudioLabel', requestedAudioName);
		selectMenuItem(audioItems, requestedAudioName);
		return;
   }
	
	if (typeof changeAudioTrack === 'function') {
        try {
            changeAudioTrack(requestedAudioName);
        } catch (err) {
            console.warn('[changeAudio] changeAudioTrack() exception. This is correct if not in SyncX:', err);
        }
    }

    const player = videojs.getAllPlayers()[0];
    const dashReady = window.isDashSource &&
        window.dashMediaPlayer &&
        typeof window.dashMediaPlayer.getTracksFor === 'function';

    if (dashReady) {
        const audioTracks = window.dashMediaPlayer.getTracksFor('audio') || [];
        for (let i = 0; i < audioTracks.length; i++) {
            const name = audioTracks[i].lang || audioTracks[i].label || `Audio ${i + 1}`;
            if (name === requestedAudioName) {
                window.dashMediaPlayer.setCurrentTrack(audioTracks[i]);
                break;
            }
        }
    } else {
        const audioTracks = player.audioTracks();
        for (let i = 0; i < audioTracks.length; i++) {
            const track = audioTracks[i];
            const name = track.label || `Audio ${i + 1}`;
            track.enabled = (name === requestedAudioName);
        }
    }

    localStorage.setItem('selectedAudioLabel', requestedAudioName);
    selectMenuItem(audioItems, requestedAudioName);
}

window.changeAudio = changeAudio;